import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import ConstructionIcon from "@mui/icons-material/Construction";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const StyledDialog = styled(Dialog)(() => ({
  "& .MuiBackdrop-root": {
    backdropFilter: "blur(8px) brightness(0.5)",
    backgroundColor: "rgba(0,0,0,0.7)",
  },
}));

const MaintenanceModal = ({ open, onClose }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleGoHome = () => {
    if (onClose) onClose();
    navigate("/");
  };

  return (
    <StyledDialog
      open={open}
      onClose={handleGoHome}
      aria-labelledby="maintenance-title"
      PaperProps={{ onClick: handleGoHome }}
    >
      <DialogTitle id="maintenance-title">
        <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
          <ConstructionIcon sx={{ color: "#FF9F1C" }} />
          <Typography component="span" fontWeight="bold">
            {t("maintenance.title")}
          </Typography>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ textAlign: "center" }}>
        <Typography sx={{ color: "#4A5A5A", mb: 1 }}>
          {t("maintenance.message")}
        </Typography>
        <Typography sx={{ color: "#7A8A8A" }}>
          {t("maintenance.note")}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
        <Button variant="contained" color="primary" onClick={handleGoHome}>
          {t("maintenance.cta")}
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};

export default MaintenanceModal;
